import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeNatureMarcheLot } from '../models/TypeNatureMarcheLot';
@Component({
  selector: 'app-type-nature-marche-lot',
  templateUrl: './type-nature-marche-lot.component.html'
})
export class TypeNatureMarcheLotComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeNatureMarcheLot'
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	  
	@Input() natureMarche : TypeNatureMarcheLot;

  constructor() { }

  public ngOnInit() {
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }  
  
  
}

